import TextEditor, { TextEditorProps } from "./TextEditor";
import { withLabel } from "composants/withLabel";

export const TextEditorAndLabel = withLabel<TextEditorProps>()(TextEditor);

export default TextEditorAndLabel;
